var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VDatePicker',_vm._b({attrs:{"value":_vm.computedValue,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_vm.onInput,"blur":_vm.onBlur}},'VDatePicker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }